
export interface FormData {
  fullName: string;
  phone: string;
  city: string;
  vehicleType: string;
  approxPrice: string;
  preferredTime: string;
  agreedToTerms: boolean;
}

export enum Cities {
  AMMAN = 'عمان',
  IRBID = 'إربد',
  AQABA = 'العقبة',
  OTHER = 'أخرى'
}

export enum ContactTimes {
  MORNING = 'الصباح (9:00 - 12:00)',
  AFTERNOON = 'الظهر (12:00 - 16:00)',
  EVENING = 'المساء (16:00 - 20:00)'
}
